export default "__VITE_ASSET__DyjsRh8N__"